import React from 'react';

const InsurancePartners = () => {
  const partners = [
    { id: 1, name: 'Ankara Sigorta', logo: '/insurance-companies/ankarasigortalogo.png' },
    { id: 2, name: 'HDI Sigorta', logo: '/insurance-companies/hdisigorta.jpg' },
    { id: 3, name: 'Hepiyi Sigorta', logo: '/insurance-companies/hepiyisigorta.jpg' },
    { id: 4, name: 'Koru Sigorta', logo: '/insurance-companies/Koru-Logo.png' },
    { id: 5, name: 'Magdeburger Sigorta', logo: '/insurance-companies/magdeburgerlogo.jpg' },
    { id: 6, name: 'Mapfre', logo: '/insurance-companies/mapfre.png' },
    { id: 7, name: 'Neova Sigorta', logo: '/insurance-companies/neovasigorta.jpg' },
    { id: 8, name: 'Quick Sigorta', logo: '/insurance-companies/quick.png' },
    { id: 9, name: 'Ray Sigorta', logo: '/insurance-companies/raysigorta.jpg' },
    { id: 10, name: 'Sompo Sigorta', logo: '/insurance-companies/somposigorta.jpg' },
    { id: 11, name: 'Türk Nippon Sigorta', logo: '/insurance-companies/turknipponsigorta.jpg' },
    { id: 12, name: 'Referans Sigorta', logo: '/insurance-companies/referans.png' },
    { id: 13, name: 'Corpus Sigorta', logo: '/insurance-companies/corpus.png' }

  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          Anlaşmalı <span className="text-blue-500">Sigorta Şirketlerimiz</span>
        </h2>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
          {partners.map((partner) => (
            <div 
              key={partner.id} 
              className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="w-full h-16 flex items-center justify-center">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-full max-w-full object-contain"
                  style={{
                    width: 'auto',
                    height: 'auto',
                    maxWidth: '100%',
                    maxHeight: '100%'
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InsurancePartners;